/* unplugin-vue-components disabled */import { render } from "./TabsBar.vue?vue&type=template&id=bd4a06e4&scoped=true"
import script from "./TabsBar.vue?vue&type=script&lang=js"
export * from "./TabsBar.vue?vue&type=script&lang=js"

import "./TabsBar.vue?vue&type=style&index=0&id=bd4a06e4&lang=scss&scoped=true"

import exportComponent from "E:\\projects\\internation-fta-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4a06e4"]])

export default __exports__